import { makeStyles } from "@material-ui/core";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import React from "react";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
    maxWidth: "100%",
    marginBottom: theme.spacing(0.75),
  },
}));

export default function FormikTextField({ maxLength = null, idPrefix = "", ...props }) {
  const classes = useStyles();

  return (
    <Field
      className={classes.root}
      id={idPrefix ? idPrefix + "-" + props.name : props.name}
      data-cy={idPrefix ? idPrefix + "-" + props.name : props.name}
      component={TextField}
      fullWidth
      {...props}
      inputProps={{ maxLength }}
      FormHelperTextProps={{ "data-cy": (idPrefix ? idPrefix + "-" + props.name : props.name) + "-helper-text" }}
    />
  );
}
